import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IAttachmentTypeFormByIdRouteProps extends PropsWithChildren {
    attachmentTypeId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const AttachmentTypeFormByIdRoute: FC<IAttachmentTypeFormByIdRouteProps> = ({
    attachmentTypeId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const attachmentTypeIdToUse = (params.attachmentTypeId ? +params.attachmentTypeId : undefined) ?? attachmentTypeId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={attachmentTypeIdToUse}
            formDefinitionIdentifier={FormDefinitions.AttachmentType}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default AttachmentTypeFormByIdRoute;
